/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';
import Link, { LinkProps } from '@material-ui/core/Link';

export type FooterLinkProps = LinkProps & RouterLinkProps;

const FooterLink = React.forwardRef<React.FC<FooterLinkProps>, FooterLinkProps>(
  (props, _ref) => {
    const { children: listItemChildren, to } = props;
    const children = React.Children.map(
      listItemChildren,
      (child) => React.isValidElement(child) && child
    );

    const renderLink = React.useMemo(
      () =>
        React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>(
          (itemProps, linkRef) => (
            <RouterLink to={to} ref={linkRef} {...itemProps} />
          )
        ),
      [to]
    );

    const toAddress =
      (typeof to === 'string' && to) ||
      (typeof to === 'object' && to.pathname) ||
      '';
    const isExternalLink = /^https?:\/\//.test(toAddress);

    // TODO: make sure using {{ pathname: https://wwww.bittitan.com }} works correctly to redirect to external url
    // (has something to do with baseUrl in AppLayout.tsx)
    return (
      <li>
        <Link
          component={isExternalLink ? 'a' : renderLink}
          href={isExternalLink ? toAddress : undefined}
          {...props}
        >
          {children}
        </Link>
      </li>
    );
  }
);

export default FooterLink;
